import { createFileRoute } from "@tanstack/react-router";

import { DeletionReceiptStatus } from "../features/settings/PrivacySettings";

/** Public route: the auth session may have been erased by the deletion worker. */
export const Route = createFileRoute("/deletion-status")({
  component: DeletionReceiptStatus,
});
